export const FROM_DATE_LIMIT = {
  THREE_MONTHS: "THREE_MONTHS",
  ONE_HUNDRED_EIGHTY_DAYS: "ONE_HUNDRED_EIGHTY_DAYS",
  THREE_HUNDRED_SIXTY_DAYS: "THREE_HUNDRED_SIXTY_DAYS",
  ONE_YEAR: "ONE_YEAR"
};

export const FROM_DATE_LIMIT_DAYS = {
  [FROM_DATE_LIMIT.THREE_MONTHS]: 90,
  [FROM_DATE_LIMIT.ONE_HUNDRED_EIGHTY_DAYS]: 180,
  [FROM_DATE_LIMIT.THREE_HUNDRED_SIXTY_DAYS]: 360
};

export const FROM_TO_KEYWORDS = {
  FROM: "from",
  TO: "to",
  START_DATE: "startDate",
  END_DATE: "endDate"
};
